module.exports = __webpack_public_path__ + "img/layla_no.c4e90f75.png";